import * as algoliasearch from 'algoliasearch';

const client = algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_SEARCH_KEY);
const productIndex = client.initIndex(`${process.env.ENV_SHORTNAME}_products`);

const algoliaProductsAction = {
  methods: {
    async getAlgoliaProduct(productIds, data, dataKey, callback, keyword, index) {
      console.log('getAlgoliaProduct')
      productIndex.search({
        query: keyword,
        distinct: true,
        page: 0,
        hitsPerPage: 1000,
        facets: productIds ? '["productId"]' : [],
        facetFilters: productIds ? `[[${productIds}]]` : [],
        attributesToRetrieve: [
          'brandName',
          'productId',
          'collectionName',
          'name',
          'roles',
          'patentsV2.roles.name',
        ],
      }, (err, content) => {
        if (err) throw err;
        callback ? callback(data, dataKey, content.hits, index) : null;
      });
    },
    async buildProductIdList(products, data, dataKey, callback, index) {
      try {
        // For each segmentation product we need to add to the query for algolia
        const query = [];
        if (products) {
          products.forEach((product) => {
            query.push(`"productId:${product}"`);
          });
        }
        await query.length ? this.getAlgoliaProduct(await query, data, dataKey, callback, '', index) : null;
      } catch (err) {
        console.log(err);
      }
    },
    async getAlgoliaProductV2(productIds, callback) {
      console.log('getAlgoliaProductV2', productIds.length)
      const attributesToRetrieve = [
        'brandName',
        'productId',
        'collectionName',
        'name',
        'roles',
        'patentsV2.roles.name',
      ];

      if (productIds.length > 0) {
        const itemsPaginated = productIds.slice(0,999)
        console.log('getAlgoliaProductV2 itemsPaginated', itemsPaginated.length)

        productIndex.getObjects(itemsPaginated, attributesToRetrieve, (err, content) => {
          if (err) throw err;
          callback ? callback(content.results) : null;
        });

        const nextItems = productIds.slice(999);
        console.log('getAlgoliaProductV2 nextItems', nextItems.length)

        this.getAlgoliaProductV2(nextItems, callback);
      }
      
      
    },
  },
};

export default algoliaProductsAction;



// WEBPACK FOOTER //
// ./src/assets/js/algoliaProductsMixin.js